<script setup>
// Google Ads > Kitleler
//
// Kitle listelerinde tarih araligi yok: liste boyutu anlik bir deger,
// donemsel degil. Bu yuzden kabukta aralik secicisi gizli.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import GoogleAdsKabuk from './GoogleAdsKabuk.vue';
import GoogleAdsTablo from './GoogleAdsTablo.vue';
import { getir, hataMetni } from './kopru.js';

const { t } = useI18n();
const route = useRoute();

const satirlar = ref([]);
const paraBirimi = ref('');
const yukleniyor = ref(false);
const hata = ref('');

const SUTUNLAR = [
  { alan: 'ad', anahtar: 'GOOGLE_ADS.SUTUN.AD', siralanabilir: true, vurgu: true },
  { alan: 'tur', anahtar: 'GOOGLE_ADS.SUTUN.TUR', tur: 'etiket', siralanabilir: true },
  { alan: 'durum', anahtar: 'GOOGLE_ADS.SUTUN.DURUM', tur: 'durum', siralanabilir: true },
  { alan: 'boyut_display', anahtar: 'GOOGLE_ADS.SUTUN.BOYUT_DISPLAY', tur: 'sayi', siralanabilir: true },
  { alan: 'boyut_arama', anahtar: 'GOOGLE_ADS.SUTUN.BOYUT_ARAMA', tur: 'sayi', siralanabilir: true },
];

const yukle = async aralik => {
  yukleniyor.value = true;
  hata.value = '';
  try {
    const veri = await getir(route.params.accountId, 'kitleler', { aralik });
    satirlar.value = veri.kitleler || [];
    paraBirimi.value = veri.para_birimi || '';
  } catch (e) {
    satirlar.value = [];
    hata.value = hataMetni(e, t('GOOGLE_ADS.HATA'));
  } finally {
    yukleniyor.value = false;
  }
};
</script>

<template>
  <GoogleAdsKabuk
    :baslik="t('GOOGLE_ADS.KITLELER')"
    :aralik-goster="false"
    @aralik="yukle"
  >
    <div class="flex flex-col gap-3">
      <p v-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>
      <div v-if="yukleniyor" class="flex justify-center p-10">
        <Spinner class="text-n-brand" />
      </div>
      <GoogleAdsTablo
        v-else
        :sutunlar="SUTUNLAR"
        :satirlar="satirlar"
        :para-birimi="paraBirimi"
        varsayilan-siralama=""
      />
    </div>
  </GoogleAdsKabuk>
</template>
